<template>
    <section class="question">
        <div class="question__animation" v-if="animation">
            <lottie-player
                ref="lottie"
                class="question__player"
                background="transparent"
                speed="1"
                loop
                autoplay></lottie-player>
        </div>
        <div class="question__content" :class="{'question__content--no-col': !animation}">
            <div class="radios" :class="{'radios--align-left': animation}">
                <p class="supertitle" v-if="questionNumber">otázka {{ questionNumber }}</p>
                <h2 class="title">{{ title }}</h2>
                <ul class="radios__list">
                    <li v-for="(item, i) in items" :key="`${name}-${i}`" class="radios__item">
                        <input type="radio" :id="`${name}-${i}`" :value="item.value" class="radios__input" :name="name">
                        <label :for="`${name}-${i}`" class="radios__label" @click="updateValue(item.value)">
                            <img :src="item.img" alt="" class="radios__img">
                            <div class="radios__text">{{ item.text }}</div>
                        </label>
                    </li>
                </ul>
                <span class="radios__error" v-if="$v.value.$error && !$v.value.required">Odpovězte prosím na otázku</span>
            </div>
            <slot></slot>
        </div>
    </section>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import animation from "@/mixins/animation";

export default {
    name: "GroheImageRadios",
    mixins: [animation],
    props: {
        items: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        questionNumber: {
            type: String
        }
    },
    data() {
        return {
            value: null,
        }
    },
    validations: {
        value: {
            required
        },
        form: ['value']
    },
    methods: {
        updateValue(value) {
            this.value = value;
        },
        validate() {
            this.$v.form.$touch();
            const isValid = !this.$v.form.$invalid;
            const value = typeof this.value === 'boolean' ? this.value : parseInt(this.value);
            this.$emit('on-validate', isValid, this.name, value);
            return isValid;
        }
    }
}
</script>

<style scoped lang="scss">
    .radios {
        &__list {
            display: flex;
            width: 100%;
            min-width: initial;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
        }
        &__item {
            width: 200px;
            height: 205px;
            margin: 8px;
        }
        &__input {
            &:checked + .radios__label {
                &:before {
                    background-size: 25px;
                    display: block;
                }
            }
        }
        &__label {
            width: 100%;
            height: 100%;
            flex-direction: column;
            padding: 25px 15px 20px 15px;
            border-radius: 5px;
            border-color: $sailor-boy;
            font-size: 15px;
            font-weight: normal;

            &:before {
                display: none;
                top: 11px;
                left: 11px;
                width: 25px;
                height: 25px;
            }
        }
        &__img {
            width: 100%;
            margin-bottom: auto;
            max-height: 65%;
            margin-top: auto
        }
        &__text {
            margin-top: 20px;
            text-align: center;
        }

        @media screen and (min-width: $mq-850) {
            &__list {
                flex-direction: row;
            }
            &__item {
                width: 227px;
                height: 250px;
                margin: 0 8px;
            }
            &__label {
                padding: 45px 25px 20px 25px;
                font-size: 18px;
            }
        }
    }
</style>
